module.exports = __webpack_public_path__ + "img/arrow-down.ce69a868.svg";